import queryString from 'query-string';
const parsedQs = queryString.parse(window.location.search);

const initialState = {
  activeFeature: null,
  searchBarVisible: false,
  searchedLocation: null,
  activePage: 'map',
  activeFilters: [],
  basemap: 'ROADMAP',
  viewingFund: parsedQs.fund,
  isFramed: window.self !== window.top,
  isMultiple: false,
  mapType: parsedQs.mapType || 'lga',
  internal: parsedQs.internal === 'true',
};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'ACTIVE_FEATURE:SET':
      return {
        ...state,
        searchedLocation: null,
        activeFeature: action.payload,
        isMultiple: false,
        activeMultipleProject: null
      };
    case 'SEARCH_BAR_VISIBLE:SET':
      return { ...state, searchBarVisible: action.payload };
    case 'SEARCHED_LOCATION:SET':
      return { ...state, searchedLocation: action.payload };
    case 'ACTIVE_PROJECT:SET':
      return {
        ...state,
        activeProject: action.payload,
        isMultiple: false,
        activeMultipleProject: null,
    };
    case 'ACTIVE_FILTER:SET': {
      const { activeFilters } = state;
      const newFilters = activeFilters.includes(action.payload)
        ? activeFilters.filter(d => d !== action.payload)
        : activeFilters.concat(action.payload);

      return { ...state, activeFilters: newFilters };
    }
    case 'ACTIVE_PAGE:SET': {
      return { ...state, activePage: action.payload };
    }
    case 'MAP_TYPE:SET': {
      return { ...state, mapType: action.payload };
    }
    case 'MAP:SET_BASEMAP': {
      return { ...state, basemap: action.payload };
    }
    case 'IS_MULTIPLE:SET': {
      return {
          ...state,
          isMultiple: action.payload ? true : false,
          activeMultipleProject: action.payload,
          activeProject: null,
          activeFeature: null,
        };
    }

    default:
      return state;
  }
};

export const selectActiveFeature = s => s.activeFeature;
export const selectSearchBarVisible = s => s.searchBarVisible;
export const selectSearchedLocation = s => s.searchedLocation;
export const selectActiveProject = s => s.activeProject;
export const selectActiveMultipleProject = s => s.activeMultipleProject;
export const selectActiveFilters = s => s.activeFilters;
export const selectActivePage = s => s.activePage;
export const selectIsFramed = s => s.isFramed;
export const selectIsMultiple = s => s.isMultiple;
export const selectMapType = s => s.mapType;
export const selectViewingFund = s => s.viewingFund;
export const selectIsInternal = s => s.internal;
export const selectBasemap = s => s.basemap;



// WEBPACK FOOTER //
// ./src/reducers/ui.js